import * as React from 'react'
function SvgDesktop(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 4H6c-1.2 0-2 .8-2 2v22c0 1.2.8 2 2 2h10v2h-4.002A1.994 1.994 0 0010 34a2 2 0 001.99 2h16.02c1.099 0 1.99-.888 1.99-2 0-1.105-.898-2-1.998-2H24v-2h10c1.2 0 2-.8 2-2V6c0-1.2-.8-2-2-2zm-2 4v14H8V8h24z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDesktop
